import React, { ReactNode } from 'react'

const Eyebrow = ({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}) => {
  return (
    <div
      className={`px-3 py-2 mono-small text-white rounded-full ring-1 ring-white-20 bg-white-05 ${className} backdrop-blur-sm`}
    >
      {children}
    </div>
  )
}

export default Eyebrow
